import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import store from "./store";
import { BrowserRouter } from "react-router-dom/dist";
import ReactGA from 'react-ga';

const root = ReactDOM.createRoot(document.getElementById("root"));
const trackingId = "G-18PWEXKFGW";
ReactGA.initialize(trackingId);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);
